module.exports = __webpack_public_path__ + "img/myapps.7002c3b.svg";